export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/spur-bf03da4fc48ae7e07e1eb65f58910af2.png";